import { useProvinceSelection } from "~/composables/useProvinceSelection"

export default defineNuxtRouteMiddleware((to, from) => {
    if (import.meta.server) return

    const { isValidProvinceSelected, openProvinceModalForCart } = useProvinceSelection()

    if (!isValidProvinceSelected.value) {
        openProvinceModalForCart()
        return navigateTo('/')
    }
})
